import { ComponentProps, FC } from 'react';
import { useTranslation } from 'next-i18next';
import { BannerBox } from '../../box/BannerBox';
import { VariationIcon } from '../VariationIcon/VariationIcon';

export const ConversionWellPriceBanner: FC<ComponentProps<typeof BannerBox>> = ({ ...props }) => {
  const { t } = useTranslation('price-drop');

  return (
    <>
      <BannerBox
        variant="success"
        title={t('PRICE_DROP.PRICE_ZONE.CONVERSION.WELL_PRICE.TITLE')}
        titleIcon={<VariationIcon name={'success'} />}
        description={t('PRICE_DROP.PRICE_ZONE.CONVERSION.WELL_PRICE.INFO')}
        showLearnMoreButton={true}
        {...props}
      />
    </>
  );
};
